import script from "./personalProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./personalProjects.vue?vue&type=script&setup=true&lang=js"

import "./personalProjects.vue?vue&type=style&index=0&id=186316a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-186316a0"]])

export default __exports__